import {
    getHeapUserId,
    trackHeapEvent,
    stringifyObjectValuesShallow,
} from '@ratehub/base-ui';


/**
 * 'Loan redirect to partner'-specific call for `trackHeapEvent`.
 * @param {object} params - the parameters for the event
 * @param {string} params.referrerURL - the URL of the referrer
 * @param {string} params.affiliateId - the ID of the affiliate
 * @param {object} params.additionalInfo - additional information for the event
 * @param {import('../definitions/LoanShape')} params.loan - the loan
 */
function trackHeapLoanRedirectEvent({ referrerURL, affiliateId, additionalInfo, loan }) {
    const {
        slug,
        provider,
        applyURL,
        giftOffer,
        isMonetized,
        isSponsored,
    } = loan;

    trackHeapEvent('Loan redirect to partner', {
        slug,
        provider: provider.name,
        href: applyURL,
        monetized: isMonetized.toString(),
        sponsored: isSponsored.toString(),
        ...(referrerURL && { refererUrl: referrerURL }),
        // refererUrl [sic] - preserve typo in property name
        ...(affiliateId && { affiliateId }),

        // simplify analytic’s tracking efforts by passing only string values to Heap
        ...stringifyObjectValuesShallow(giftOffer),
        ...stringifyObjectValuesShallow(additionalInfo),
        heapId: getHeapUserId(),
    });
}


export default trackHeapLoanRedirectEvent;
